import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer">
      <div className="container footer__inner">
        <div className="footer-columns">
          <div className="footer-col">
            <h4>CUSTOMER SERVICE</h4>
            <ul>
              <li>
                <Link onClick={toTop} to="/contact">
                  Contact Us
                </Link>
              </li>

              <li>
                <Link onClick={toTop} to="/returns">
                  Returns &amp; Exchanges
                </Link>
              </li>
              <li>
                <Link onClick={toTop} to="/shipping">
                  Shipping Information
                </Link>
              </li>
            </ul>

            <h4>ABOUT US</h4>
            <ul>
              <li>
                <Link onClick={toTop} to="/about">
                  Our Factory
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-signup">
            <p>qty@retteve.store</p>

            <div className="social">
              <Link
                onClick={toTop}
                to="/instagram"
                className="social-icon"
                aria-label="instagram"
              >
                IG
              </Link>
              <Link
                onClick={toTop}
                to="/facebook"
                className="social-icon"
                aria-label="facebook"
              >
                FB
              </Link>
              <Link
                onClick={toTop}
                to="/pinterest"
                className="social-icon"
                aria-label="pinterest"
              >
                P
              </Link>
              <Link
                onClick={toTop}
                to="/youtube"
                className="social-icon"
                aria-label="youtube"
              >
                YT
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom container">
        <div className="copyright">
          © 2026 Williams-Sonoma, Inc. All Rights Reserved
        </div>
        <div className="footer-legal-links">
          <Link onClick={toTop} to="/terms">
            Terms &amp; Conditions
          </Link>{" "}
          |{" "}
          <Link onClick={toTop} to="/privacy">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
